// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "amenities-24BLZ";
export { _1 as "__esModule", _2 as "amenities" }
export default { "__esModule": _1, "amenities": _2 }
